import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Row, Col, Card, Statistic } from "antd";
import * as moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";

import LoadingPage from "../../components/LoadingPage";
import Error404Page from "../../components/Error404Page";

import { getRobotStats } from "../robot/robotSlice";

momentDurationFormatSetup(moment);

const INITIAL_DATE = "2010-01-01"; // Default date to query day 1 of weld

const RobotStatsCard = (props) => {
  const { robotId } = props;
  const stats = useSelector((state) => state.robot.stats);

  const lastNDays = {
    key: 1,
    title: "Last 1 month",
    value: 1,
    date: moment().subtract(1, "month"),
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getRobotStats(robotId, {
        initial: INITIAL_DATE,
        recent: lastNDays.date.format("YYYY-MM-DD"),
      })
    );
  }, [dispatch, robotId]);

  if (!robotId) {
    return <Error404Page />;
  }

  if (!stats || (stats.length > 0 && stats[robotId])) {
    return <LoadingPage />;
  }

  const robotStats = stats[robotId];

  const data = {
    totalWeldTimes: robotStats.totalWeldTimes.slice(1).reduce((prev, curr) => {
      return prev.add(curr.value);
    }, moment.duration(robotStats.totalWeldTimes[0].value) || 0)._data,

    weldTimes: robotStats.weldTimes.slice(1).reduce((prev, curr) => {
      return prev.add(curr.value);
    }, moment.duration(robotStats.weldTimes[0].value) || 0)._data,

    totalWeldInches: robotStats.totalWeldInches.reduce((prev, curr) => {
      return prev + curr.value;
    }, 0),
    weldInches: robotStats.weldInches.reduce((prev, curr) => {
      return prev + curr.value;
    }, 0),
  };

  return (
    <Row gutter={[4, 4]} style={{ paddingBottom: 10 }}>
      <Col span={6}>
        <Card>
          <Statistic
            className="RobotStats_Content"
            title={""}
            value={data.weldInches}
            formatter={(value) => {
              return value.toFixed(1) + "″";
            }}
          />
          <Statistic
            className="RobotStats_Title"
            title="Weld FDI (30 days)"
            value={""}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            className="RobotStats_Content"
            title={""}
            value={moment.duration(data.weldTimes).asMilliseconds()}
            formatter={(value) =>
              moment.duration(value, "milliseconds").format("d [days] hh:mm:ss")
            }
          />
          <Statistic
            className="RobotStats_Title"
            title="Arc Time (30 days)"
            value={" "}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            className="RobotStats_Content"
            title={""}
            value={data.totalWeldInches}
            formatter={(value) => {
              return value.toFixed(1) + "″";
            }}
          />
          <Statistic
            className="RobotStats_Title"
            title="Weld FDI (Overall)"
            value={" "}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            className="RobotStats_Content"
            title={""}
            value={moment.duration(data.totalWeldTimes).asMilliseconds()}
            formatter={(value) =>
              moment.duration(value, "milliseconds").format("d [days] hh:mm:ss")
            }
          />
          <Statistic
            className="RobotStats_Title"
            title="Arc Time (Overall)"
            value={" "}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default RobotStatsCard;
